export const getImageUrl = (relativePath) => {
  // Remove "/api" from the base URL
  const baseUrl = process.env.REACT_APP_API_BASE_URL.replace('/api', '');

  // Replace backslashes with forward slashes in the relative path
  return `${baseUrl}/${relativePath?.replace(/\\/g, '/')}`;
};
